import { supabase } from '../lib/supabaseClient.js';
import { TABLES } from '../lib/constants.js';

export async function listProperties() {
  const { data, error } = await supabase.from(TABLES.PROPERTIES).select('*').order('created_at', { ascending: true });
  if (error) throw error;
  return data;
}

export async function addProperty({ name, code, location, floors }) {
  const { data, error } = await supabase.from(TABLES.PROPERTIES)
    .insert({ name, code, location, floors, units_count: 0, notes: '' })
    .select().single();
  if (error) throw error;
  return data;
}

export async function updateProperty(id, patch) {
  const { data, error } = await supabase.from(TABLES.PROPERTIES).update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

/** حذف عقار مع تأكيد — يُنفَّذ من الواجهة بعد تأكيد المستخدم فقط.
 *  ملاحظة: إن كانت هناك شقق/تذاكر مرتبطة، قاعدة البيانات (foreign key)
 *  يجب أن تمنع الحذف أو تفرض ON DELETE RESTRICT — تأكد من ذلك في Schema لديك
 *  بدل الاعتماد على الواجهة فقط لمنع حذف عقار به بيانات. */
export async function deleteProperty(id) {
  const { error } = await supabase.from(TABLES.PROPERTIES).delete().eq('id', id);
  if (error) throw error;
}

export function subscribeProperties(onChange) {
  return supabase.channel('properties-changes')
    .on('postgres_changes', { event: '*', schema: 'public', table: TABLES.PROPERTIES }, onChange)
    .subscribe();
}
